import React, { useEffect } from 'react';
import { Button, Form, SelectInput, spacing, TextInput, useHonestFormContext } from '@digitools/honest-ui';
import { getSearchValidator } from '../../../status/components/pages/EmployeeSearch/EmployeeSearchForm';
import { useNavigate } from 'react-router-dom';
import { TEALIUM_EVENT } from '../../../../constants/tealiumConstants';
import useTealium from '../../../../hooks/useTealium';
import useAuthentication from '../../../../hooks/useAuthentication';
import styled from 'styled-components';
const submitEmployeeSearch = (values, navigate) => {
    navigate(`/status/employer/search?search=${values.search}&searchCrit=${values.searchCriteria}`);
};
const SEARCH_FIELDS = {
    empLastName: { label: 'Employee name', placeholder: 'Last name, first name' },
    empId: { label: 'Employee ID', placeholder: 'Search' },
    claimNum: { label: 'Claim or leave number', placeholder: 'Search' },
    accommodationEventId: { label: 'Accommodation event ID', placeholder: 'Search' },
};
const ViewStatusForm = styled((Form)) `
    display: flex;
    flex-direction: column;
    gap: ${spacing.xs};
    button { align-self: flex-start; }
`;
// Adapts the shared EmployeeSearchForm validators, which return LanguageToggle,
//  to honest-ui's contract (string). This form renders only in the Employer experience so english-only is correct.
// Delete once EmployeeSearchForm moves to honest-ui and shared validators are updated to return strings.
const toHonestValidator = (validate) => (value) => validate(value)?.props.en;
const ViewRequestStatusFormFields = () => {
    const { watch, setValue, clearErrors } = useHonestFormContext();
    const { user } = useAuthentication();
    const searchCriteria = watch('searchCriteria');
    useEffect(() => {
        // Changing search criteria option also changes which validation rule applies to the search field,
        // so reset the field rather than carrying a value — or a stale error — across.
        setValue('search', '');
        clearErrors('search');
    }, [searchCriteria, setValue, clearErrors]);
    const isStatusERWithAccommodation = !!user?.applicationPermissions?.includes('statusER.viewAccommodationStatus.viewBasicAsRequest');
    const options = [
        { label: SEARCH_FIELDS.empLastName.label, value: 'empLastName' },
        { label: SEARCH_FIELDS.empId.label, value: 'empId' },
        { label: SEARCH_FIELDS.claimNum.label, value: 'claimNum' },
        ...(isStatusERWithAccommodation
            ? [{ label: SEARCH_FIELDS.accommodationEventId.label, value: 'accommodationEventId' }]
            : []),
    ];
    return (<>
            <SelectInput name="searchCriteria" label="Search criteria" placeholder="Select" options={options} required dark/>
            {searchCriteria && (<TextInput name="search" label={SEARCH_FIELDS[searchCriteria].label} placeholder={SEARCH_FIELDS[searchCriteria].placeholder} required validate={toHonestValidator(getSearchValidator(searchCriteria))} autoComplete="off" dark/>)}
            <Button label="Search" type="primary-dark" htmlType="submit"/>
        </>);
};
const ViewRequestStatusForm = () => {
    const navigate = useNavigate();
    const { trackEvent } = useTealium();
    return (<ViewStatusForm defaultValues={{ searchCriteria: '', search: '' }} onSubmit={(values) => {
            submitEmployeeSearch(values, navigate);
            trackEvent({
                event_action: TEALIUM_EVENT.EVENT_ACTION.SEARCH,
                event_type: TEALIUM_EVENT.EVENT_TYPE.HOME_PAGE,
                event_name: values.searchCriteria,
                event_version: TEALIUM_EVENT.EVENT_TYPE.LANDING_PAGE_BANNER,
            });
        }}>
            <ViewRequestStatusFormFields />
        </ViewStatusForm>);
};
export default ViewRequestStatusForm;
